import { useChannelSelected } from '@/hooks/useChannelSelected';
import { IChanelProps } from '@/types/components/channels';
import { memo } from 'react';
import ChannelsButton from '.';
const Twitter = ({ keyValue }: IChanelProps) => {
  const channel = useChannelSelected(keyValue).channel;

  return channel ? (
    <ChannelsButton
      key={keyValue}
      keyValue={keyValue}
      placeholder="Example: Twitter_username"
      tooltip={`Add the username of of your Twitter profile. For "twitter.com/example " the username is "example"`}
    />
  ) : null;
};
export default memo(Twitter);
